import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { SetScreenSizeCssClass } from "../../AppMenu/Store";
import ProfilePictureModal from "./ProfilePictureModal";
import IconSvg from "../../SharedComponents/IconSvg";
import HamburgerMenuIcon from "../../AppMenu/Components/HamburgerMenuIcon";
import ProfileDropdown from "./ProfileDropdown";

export default function TopNavigation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);
  const companyUsername = useSelector((state) => state.auth?.user?.companyUser?.companyUsername);
  const userName = useSelector((state) => state.auth?.user?.name);

  // original code always used "40" — preserved here
  let size = window.innerWidth <= 500 ? "40" : "40";

  return (
    <>
      <ProfilePictureModal />

      <Row className="justify-content-between h-100">
        {windowSizeCssClass === ("mobile-screen collapsed" || "mobile-screen extended") && (
          <Col xs="auto" className="align-content-center text-end" style={{ minWidth: 106 }}>
            <button
              className="d-xl-none bg-transparent p-0 border-2 rounded-circle"
              style={{ height: "50px", width: "50px", borderColor: "#fff" }}
              onClick={() => dispatch(SetScreenSizeCssClass("mobile-screen extended"))}
            >
              <HamburgerMenuIcon isWhite={true} isOpen={windowSizeCssClass === "mobile-screen extended"} />
            </button>
          </Col>
        )}

        <Col xs="auto" className="align-content-center" style={{ minWidth: 106 }}>
          <Row className="justify-content-center ms-xl-4 ms-sm-2">
            <Col xs="auto" className="align-content-center ms-lg-5">
              <IconSvg icon="cp-logo" height={size} width={size} fill="#ffffff" />
            </Col>
            <Col xs="auto" className="text-32 lh-1 text-color-white fw-medium d-none d-md-block">
              Cus-Pro
            </Col>
          </Row>
        </Col>

        <Col className="align-content-center d-sm-block d-none ms-2 ms-md-5">
          <Row className="text-32 fw-medium text-color-white">
            <Col xs="auto" className="px-0">
              {t("headerHello")}
            </Col>
            <Col xs="auto">{companyUsername || userName}!</Col>
          </Row>
        </Col>

        <Col xs="auto" style={{ margin: "10px" }}>
          <ProfileDropdown />
        </Col>
      </Row>
    </>
  );
}
